import { useEffect} from 'react'
import { useMap } from 'react-leaflet'

const InvalidateSize = (props) => {
    const { isMapView } = props
    const map = useMap();
    
    useEffect(() => {
        if(isMapView){
          map.invalidateSize();
        }
    }, [isMapView])
    return null;
}

export default InvalidateSize;